import { FileCheck2, ScanEye, BadgeCheck, Smartphone, HeartHandshake, KeyRound } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { WHY_POINTS } from "@/data/content";

const ICONS = { FileCheck2, ScanEye, BadgeCheck, Smartphone, HeartHandshake, KeyRound };

export const WhyOmsivo = () => (
    <section id="why" data-testid="why-omsivo-section" className="blueprint noise relative overflow-hidden py-24 lg:py-36">
        <div className="pointer-events-none absolute -left-40 top-0 h-[420px] w-[420px] rounded-full bg-omsivo-blue/30 blur-[130px]" />
        <div className="relative z-10 mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-10">
            <SectionHeading
                id="why-heading"
                dark
                overline="Why OMSIVO"
                title={<>Construction, <span className="text-flame">without the chaos.</span></>}
                description="OMSIVO is built around one idea — construction should be clear, structured and centred on the customer."
            />
            <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
                {WHY_POINTS.map((p, i) => {
                    const Icon = ICONS[p.icon];
                    return (
                        <Reveal key={p.title} delay={0.06 * i}>
                            <div className="lift-card group h-full rounded-2xl border border-white/10 bg-white/[0.04] p-7 backdrop-blur-sm"
                                data-testid={`why-card-${i}`}>
                                <div className="flex items-start justify-between">
                                    <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-flame/15 text-flame transition-colors group-hover:bg-flame group-hover:text-white">
                                        <Icon className="h-6 w-6" />
                                    </div>
                                    <span className="font-mono text-[10px] text-white/25">0{i + 1}</span>
                                </div>
                                <h3 className="mt-6 font-display text-lg font-extrabold uppercase tracking-[0.08em] text-white">{p.title}</h3>
                                <p className="mt-2 text-sm leading-relaxed text-white/60">{p.text}</p>
                            </div>
                        </Reveal>
                    );
                })}
            </div>
        </div>
    </section>
);
